import { HeaderNavItem } from '../header-nav-item/HeaderNavItem';
import cx from 'classnames';
import { FC } from 'react';
import { Conditional } from '../../common';
import styles from './HeaderAccount.module.scss';
import { HeaderAccountProps } from './types';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';
import { CatIconPerson } from 'blocks-nextjs/blocks-react/components/Icons/Person';

export const HeaderAccount: FC<HeaderAccountProps> = ({
  dealerCustomerNumber,
  displayHeaderAccountLabel,
  handleDrawerProps,
  id,
  isCurrent,
  label,
  roleLabel,
  showRole
}) => {
  return (
    <HeaderNavItem
      aria-label={label}
      data-testid="cat-header-sign-in-icon"
      id={id}
      isCurrent={isCurrent}
      {...handleDrawerProps}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={MAIN_NAV_TRACK.MY_ACCOUNT_DRAWER_TEXT}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      role="menu"
    >
      <div className=" d-md-none">
        <CatIconPerson size="lg" />
      </div>
      <div className="d-none d-md-block d-lg-none">
        <CatIconPerson size="lg" />
      </div>
      <div className=" d-none d-lg-block">
        <CatIconPerson />
      </div>
      {displayHeaderAccountLabel ? (
        <div className={cx('text-capitalize', styles['header__account-label'])}>
          <p className="text-truncate m-0 cat-u-theme-typography-label-sm">
            {label}
          </p>
          <Conditional test={!!showRole}>
            <p className="text-truncate m-0 cat-u-theme-typography-label-sm">
              {roleLabel}
            </p>
          </Conditional>
          <Conditional test={!!dealerCustomerNumber}>
            <p className="text-truncate mb-0 cat-u-theme-typography-label-sm">
              DCN: #{dealerCustomerNumber}
            </p>
          </Conditional>
        </div>
      ) : null}
    </HeaderNavItem>
  );
};
